import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Role } from './role';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class RoleService {

    private api_url = `${environment.ApiUrl}/role`;

    constructor(private http: HttpClient) { }

    find(id: number) {
        return this.http.get<Role[]>(`${this.api_url}/${id}`);
    }

    findAll() {
        return this.http.get<Role[]>(this.api_url);
    }

    save(role: Role) {
        return this.http.post<Role>(this.api_url, role, httpOptions);
    }

    update(role: Role) {
        return this.http.put<Role>(this.api_url, role, httpOptions);
    }

    delete(role: Role) {
        const url = `${this.api_url}/${role.id}`;
        return this.http.delete(url, httpOptions);
    }
}